function PhoneValidator() { }

PhoneValidator.prototype.validatePhoneCell = function (phone, cellphone) {
    const phone_filled = (phone != null && phone.trim() != "");
    const cellphone_filled = (cellphone != null && cellphone.trim() != "");

    if (!phone_filled && !cellphone_filled) {        
        return false;
    }

    const isTelefoneValid = phone_filled ? this.validatePhone(phone, '(##) ####-####') : false;
    const isCelularValid = cellphone_filled ? this.validatePhone(cellphone, '(##) #####-####') : false;

    if (phone_filled && !isTelefoneValid) {        
        return false;
    }

    if (cellphone_filled && !isCelularValid) {
        return false;
    }

    return true;
}

PhoneValidator.prototype.validatePhone = function (value, mask) {
    const numbersOnly = value.replace(/\D/g, '');
    const maskNumbersOnlyLength = mask.match(/#/g)?.length || 0;
    return numbersOnly.length === maskNumbersOnlyLength;
}

PhoneValidator.prototype.install = function (app) {
    app.phoneValidator = this;
    app.config.globalProperties.$phoneValidator = this;
}

export function PhoneValidatorPlugin() {
    return new PhoneValidator();
}